import {SizeUnit} from '../Properties';

export const extractUnitAndValue = (
    value?: string | number,
    fallback: string | number = 0,
    fallbackUnit: SizeUnit = 'px'
): {unit: SizeUnit; value: number | string} => {
    if (!value) {
        return {unit: fallbackUnit, value: fallback};
    }

    if (value === 'auto') {
        return {value: 'auto', unit: 'auto'};
    }

    const processedValue = (value + '')[0] === '.' ? '0' + value : value + '';

    const valueWithoutUnit = typeof value === 'number' ? value : parseFloat(value);
    const unit =
        typeof value === 'number' ? 'px' : (processedValue.replace(valueWithoutUnit.toString(), '') as SizeUnit);

    if (Number.isNaN(valueWithoutUnit) || typeof valueWithoutUnit !== 'number') {
        return {unit: unit || fallbackUnit, value: fallback};
    }

    return {unit: unit || fallbackUnit, value: valueWithoutUnit};
};

export const extractNumericUnitAndValue = (
    value?: string | number,
    fallback = 0,
    fallbackUnit: SizeUnit = 'px'
): {unit: SizeUnit; value: number} => {
    if (!value) {
        return {unit: fallbackUnit, value: fallback};
    }

    const valueWithoutUnit = typeof value === 'number' ? value : parseFloat(value);
    const unit = typeof value === 'number' ? 'px' : (value.replace(valueWithoutUnit.toString(), '') as SizeUnit);

    if (Number.isNaN(valueWithoutUnit) || typeof valueWithoutUnit !== 'number') {
        return {unit, value: fallback};
    }

    return {unit, value: valueWithoutUnit};
};
